import { Star } from "lucide-react";
import type { FC } from "react";
import { AdvisorConfirmAction } from "web_myplann/Advisor/Components/AdvisorConfirmAction";
import { useSetMainAdvisor } from "web_myplann/Advisor/Hooks/useSetMainAdvisor";
import type { AdvisorConfirmCopy } from "web_myplann/Advisor/Types/AdvisorConfirmCopy";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Advisor;

const setMainCopy: AdvisorConfirmCopy = {
	title: R.mainConfirm.title,
	description: R.mainConfirm.description,
	confirmLabel: R.mainConfirm.confirm,
};

type Props = {
	advisor?: AgentAssignedListItemResponseDTO;
};

export const AdvisorSetMainAction: FC<Props> = ({ advisor }) => {
	const { canSetMain, isPending, confirmSetMain } = useSetMainAdvisor(advisor);

	return (
		<AdvisorConfirmAction
			advisor={advisor}
			visible={canSetMain}
			icon={Star}
			ariaLabel={R.makeMainAria}
			copy={setMainCopy}
			isPending={isPending}
			onConfirm={confirmSetMain}
		/>
	);
};
